import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sem is-sem layout-mode--rows layout-height--auto" }
const _hoisted_2 = { class: "sem is-sem set-padding--larger" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  id: "logo",
  src: "",
  alt: "Stratsys Logo"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "sem is-sem set-display--flex set-align-items--center set-flex-grow--1 set-padding-bottom--largest" }

import { useLanguage } from '@/lang/language'
import { computed, onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { currentLanguage } = useLanguage()
const homePage = computed(() => {
  switch (currentLanguage.value) {
    case 'sv':
      return 'https://www.stratsys.com/sv'
    case 'nb':
      return 'https://www.stratsys.com/no'
    default:
      return 'https://www.stratsys.com'
  }
})

onMounted(() => {
  setLogo(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches)

  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function (event) {
    setLogo(event.matches)
  })
})

function setLogo(isMatch: boolean) {
  const el = document.getElementById('logo') as HTMLImageElement

  if (el) {
    el.src = isMatch
      ? require('@/assets/stratsys-light.svg')
      : require('@/assets/stratsys-dark.svg')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_one_ux_scroll = _resolveComponent("one-ux-scroll")!

  return (_openBlock(), _createBlock(_component_one_ux_scroll, {
    height: "max",
    width: "max"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("a", {
            class: "sem is-interactive",
            href: _unref(homePage)
          }, _hoisted_5, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_RouterView)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})